import { render, staticRenderFns } from "./LetterAvatar.vue?vue&type=template&id=c8147e6c&scoped=true"
import script from "./LetterAvatar.vue?vue&type=script&lang=js"
export * from "./LetterAvatar.vue?vue&type=script&lang=js"
import style0 from "./LetterAvatar.vue?vue&type=style&index=0&id=c8147e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8147e6c",
  null
  
)

export default component.exports